import {ethers} from "ethers";
import { ERC20ABI } from "./abi/ERC20ABI";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";

export class ERC20Contract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, ERC20ABI.GetABI(), provider);
    }

    async name(): Promise<string>
    {
        return this._call("name");
    }

    async decimals(): Promise<string>
    {
        return this._call("decimals");
    }

    async symbol(): Promise<string>
    {
        return this._call("symbol");
    }   

    async totalSupply(): Promise<string>
    {
        const res = await this._call("totalSupply");
        return this._toDecimal(res);
    }   

    async transfer(to:string, amountEth:string): Promise<any>
    {
        const result = await this._send('transfer', to, this._toWei(amountEth)); 
    }

    async approve(spenderAddr:string, amountEth:string): Promise<boolean>
    {
        const result = await this._send('approve', spenderAddr, this._toWei(amountEth)); 
        return result;
    }

    async allowance(ownerAdr:string, spenderAdr:string): Promise<string>
    {
        const res = await this._call("allowance", ownerAdr, spenderAdr);
        return this._toDecimal(res);
    }   

    async balanceOf(address:string)
    {
        const res = await this._call("balanceOf", address);
        return this._toDecimal(res);
    }
    
}